export enum Constants {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE',
  COMPLAINT = 'COMPLAINT',
  CLAIM = 'CLAIM',
  PRINT_PDF_ACTION = 'printClaimPDF',
  DOWNLOAD_PDF_ACTION = 'downloadClaimPDF',
}
